module.exports = __webpack_public_path__ + "img/n6.e6e9fc44.jpg";